import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import ModalHeader from 'components/Modal/ModalHeader';
import { reduxForm, FieldArray, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { onCancelItemVariantModal } from 'actions/businessLibrary/item';
import ItemVariantFieldArray from './ItemVariantFieldArray';
import styles from './ItemVariantModal.css';

const validate = values => {
  const errors = {};

  const itemVariantsErrors = [];
  if (values.item_variants) {
    values.item_variants.forEach((iv, index) => {
      const memberError = {};
      if (!iv.name && values.item_variants.length > 1) {
        memberError.name = 'Please fill in Variant Name';
      }
      if (iv.price > 99999999999) {
        memberError.price = 'Price must be less than 99.999.999.999';
      }
      if (Object.keys(memberError).length > 0) {
        itemVariantsErrors[index] = memberError;
      }
    });
  }
  if (itemVariantsErrors.length) {
    errors.item_variants = itemVariantsErrors;
  }

  return errors;
};

class ItemVariantModal extends React.Component {
  render() {
    const {
      showItemVariantModal,
      handleSubmit,
      subscriptionDetail,
      item_form: {
        is_sales_type_price: isSalesTypePrice,
        sales_type: salesType,
      },
    } = this.props;

    return (
      <Modal
        show={showItemVariantModal}
        onHide={this._onCancel}
        dialogClassName={`modal-dialog ${styles.dialog}`}
      >
        <ModalHeader title={'Add Variant'} />
        <form onSubmit={handleSubmit}>
          <Modal.Body bsClass={`modal-body ${styles.body}`}>
            <FieldArray
              name="item_variants"
              component={ItemVariantFieldArray}
              props={{
                ingredientSubscriptionDetail: subscriptionDetail,
                isSalesTypePrice,
                salesType,
              }}
            />
          </Modal.Body>
          <Modal.Footer>
            <span className="pull-left">
              <button
                className="btn btn-default"
                type="button"
                onClick={this._onCancel}
              >
                Cancel
              </button>
            </span>
            <span className="pull-right">
              <button className="btn btn-primary" type="submit">
                Confirm
              </button>
            </span>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

  _onCancel = () => {
    const { dispatch, previousItemForm } = this.props;
    dispatch(onCancelItemVariantModal(previousItemForm));
  };
}

function mapStateToProps(state) {
  const {
    showItemVariantModal,
    previousItemForm,
  } = state.businessLibrary.itemHub;
  const {
    ingredientSubscription: { subscriptionDetail },
  } = state.ingredients;
  return {
    showItemVariantModal,
    previousItemForm,
    subscriptionDetail,
    item_form: getFormValues('itemHub')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

ItemVariantModal.propTypes = {
  onSubmit: PropTypes.func,
  dispatch: PropTypes.func,
};

const mapForm = {
  form: 'modal_item_variants',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

export default reduxForm(mapForm)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ItemVariantModal)
);
